import { Space } from 'antd';
import styled from 'utils/styled';

export const Container = styled.div`
`;

export const StyledSpace = styled(Space)`
  width: 100%;
`;

export const ButtonRow = styled.div`
  display: flex;
  align-items: center;
  grid-template-columns: repeat(auto-fit, minmax(30px, 50px));
`;
